import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import { AuthModalContext } from '@/context/AuthModalContextProvider';
import SvgCalendarOutline from 'icons/calendar-outline.svg';
import SvgClockOutline from 'icons/clock-outline.svg';
import SvgGlasses from 'icons/goal-focus-outline.svg';
import SvgMindOutline from 'icons/mind-outline.svg';

import messages from './messages';
import { Description, Icon, Icons, Wrapper } from './styles';

const LoggedOut = () => {
	const { formatMessage } = useIntl();
	const { setIsModalOpen } = useContext(AuthModalContext);

	const onAuthClick = () => {
		if (setIsModalOpen) {
			setIsModalOpen(true);
		}
	};

	return (
		<Wrapper>
			<Icons>
				<Icon as={SvgGlasses} />
				<Icon as={SvgMindOutline} />
				<Icon as={SvgCalendarOutline} />
				<Icon as={SvgClockOutline} />
			</Icons>
			<Description>{formatMessage(messages.loggedOutDescription)}</Description>
			<Button fullWidth backgroundColor="white" textColor="black" onPress={onAuthClick}>
				{formatMessage(messages.cta)}
			</Button>
		</Wrapper>
	);
};

export default LoggedOut;
